import { Box, css, styled } from '@goodrx/matisse-react';
export const Divider = styled(Box).attrs(({
  theme,
  ...props
}) => ({
  bg: theme.colors.greyLight,
  my: theme.space[3],
  ...props
}))(() => css`
    width: 100%;
    height: 1px;
  `);